import { render, staticRenderFns } from "./customer-call-log-list.vue?vue&type=template&id=461847d8"
import script from "./customer-call-log-list.vue?vue&type=script&lang=js"
export * from "./customer-call-log-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports